import {defineStore} from 'pinia'
import {computed, Ref, ref} from 'vue'

export const usePageStore =  defineStore('page',()=>{
	
	const el:any = document.querySelector('#pageData');
	let pageData;
	if(el){
		pageData = JSON.parse(el.innerText);
	}else{
		pageData = {};
	}

	
	return {
		pageData
	}
})